const Template = `
<h2><strong class="ql-size-huge">About Us:</strong></h2>
<p><br></p>
<p><span class="ql-size-large">From concept to launch, we handle every stage of the development process, ensuring a seamless and efficient experience. Our apps are designed to engage, inform, and entertain, providing a valuable experience for your customers. Let us help you reach new heights with a cutting-edge mobile app that sets you apart from the competition!</span></p>
<h2><br></h2>
<h2><strong class="ql-size-huge">Job Description:</strong></h2>
<p><br></p>
<h2><strong class="ql-size-large" style="color: rgb(33, 158, 188);">–</strong><strong class="ql-size-large"> Who Are We Looking For</strong></h2>
<p><br></p>
<ul>
  <li><span class="ql-size-large">Passionate and driven individuals.</span></li>
  <li><span class="ql-size-large">Knowledge of basic concepts of OOP and DSA.</span></li>
  <li><span class="ql-size-large">Excellent problem-solving skills and attention to detail.</span></li>
  <li><span class="ql-size-large">Ability to work in a fast-paced environment.</span></li>
  <li><span class="ql-size-large">Strong communication and teamwork abilities.</span></li>
  <li><span class="ql-size-large">Eagerness to learn and adapt to new technologies.</span></li>
  <li><span class="ql-size-large">Must be a graduate.</span></li>
</ul>
<p><br></p>
<h2><strong class="ql-size-large" style="color: rgb(33, 158, 188);">– </strong><strong class="ql-size-large">What You Will Do</strong></h2>
<p><br></p>
<ul>
  <li><span class="ql-size-large">Collaborate with cross-functional teams to define project requirements.</span></li>
  <li><span class="ql-size-large">Write clean, scalable, and maintainable code.</span></li>
  <li><span class="ql-size-large">Participate in code reviews and testing.</span></li>
  <li><span class="ql-size-large">Work closely with designers and product managers to create user-friendly applications.</span></li>
  <li><span class="ql-size-large">Troubleshoot and debug software issues.</span></li>
  <li><span class="ql-size-large">Stay up-to-date with industry trends and technologies.</span></li>
</ul>
<p><br></p>
<h2 class="ql-align-justify"><strong class="ql-size-large" style="color: rgb(33, 158, 188);">– </strong><strong class="ql-size-large">Required Skills</strong></h2>
<p><br></p>
<ul>
  <li><span class="ql-size-large">Create and enhance mobile applications using React Native.</span></li>
  <li><span class="ql-size-large">Solid background in software development.</span></li>
  <li><span class="ql-size-large">Familiarity with RESTful APIs and integration.</span></li>
  <li><span class="ql-size-large">Knowledge of version control systems (Git, GitHub).</span></li>
  <li><span class="ql-size-large">Excellent communication and teamwork skills.</span></li>
  <li><span class="ql-size-large">Strong understanding of UI/UX principles.</span></li>
</ul>
`;

export default Template;
